import SvgIcon from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export function StepOneIcon(): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto' }}>
      <svg aria-hidden="true" fill="none" height="40" viewBox="0 0 40 40" width="40">
        <path
          d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
          fill="#DBEAFE"
        />
        <path
          d="M21.767 14.3636V26H19.6591V16.4148H19.5909L16.8693 18.1534V16.2216L19.7614 14.3636H21.767Z"
          fill="#155DFC"
        />
      </svg>
    </SvgIcon>
  );
}

export function StepTwoIcon(): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto' }}>
      <svg
        aria-hidden="true"
        fill="none"
        height="40"
        viewBox="0 0 40 40"
        width="40"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
          fill="#D0FAE5"
        />
        <path
          d="M16.0341 26V24.4773L20.0739 20.517C20.4602 20.1269 20.7822 19.7803 21.0398 19.4773C21.2973 19.1742 21.4905 18.8807 21.6193 18.5966C21.7481 18.3125 21.8125 18.0095 21.8125 17.6875C21.8125 17.3201 21.7292 17.0057 21.5625 16.7443C21.3958 16.4792 21.1667 16.2746 20.875 16.1307C20.5833 15.9867 20.2519 15.9148 19.8807 15.9148C19.4981 15.9148 19.1629 15.9943 18.875 16.1534C18.5871 16.3087 18.3636 16.5303 18.2045 16.8182C18.0492 17.1061 17.9716 17.4489 17.9716 17.8466H15.9659C15.9659 17.108 16.1345 16.4659 16.4716 15.9205C16.8087 15.375 17.2727 14.9527 17.8636 14.6534C18.4583 14.3542 19.1402 14.2045 19.9091 14.2045C20.6894 14.2045 21.375 14.3504 21.9659 14.642C22.5568 14.9337 23.0152 15.3333 23.3409 15.8409C23.6705 16.3485 23.8352 16.928 23.8352 17.5795C23.8352 18.0152 23.7519 18.4432 23.5852 18.8636C23.4186 19.2841 23.125 19.75 22.7045 20.2614C22.2879 20.7727 21.7027 21.392 20.9489 22.1193L18.9432 24.1591V24.2386H24.0114V26H16.0341Z"
          fill="#009966"
        />
      </svg>
    </SvgIcon>
  );
}

export function FilterElementsActionIcon(): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto' }}>
      <svg
        aria-hidden="true"
        fill="none"
        height="48"
        viewBox="0 0 48 48"
        width="48"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
          fill="#DBEAFE"
        />
        <path
          d="M22.3334 30.6667C22.3333 30.8215 22.3764 30.9733 22.4578 31.1051C22.5392 31.2368 22.6557 31.3433 22.7942 31.4125L24.4609 32.2458C24.5879 32.3093 24.7291 32.3393 24.8711 32.3329C25.013 32.3264 25.1509 32.2838 25.2717 32.2091C25.3925 32.1344 25.4922 32.03 25.5614 31.9059C25.6305 31.7818 25.6668 31.6421 25.6667 31.5V25.6667C25.6669 25.2537 25.8204 24.8554 26.0975 24.5492L32.1167 17.8917C32.2246 17.7721 32.2955 17.6239 32.3209 17.4649C32.3464 17.3059 32.3252 17.1429 32.2599 16.9957C32.1947 16.8485 32.0882 16.7234 31.9534 16.6354C31.8185 16.5474 31.661 16.5004 31.5 16.5H16.5C16.3389 16.5001 16.1812 16.5468 16.0461 16.6347C15.911 16.7225 15.8042 16.8477 15.7388 16.995C15.6733 17.1422 15.652 17.3053 15.6774 17.4645C15.7027 17.6236 15.7737 17.772 15.8817 17.8917L21.9025 24.5492C22.1796 24.8554 22.3332 25.2537 22.3334 25.6667V30.6667Z"
          stroke="#155DFC"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
      </svg>
    </SvgIcon>
  );
}

export function ExploreElementsActionIcon(): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto' }}>
      <svg
        aria-hidden="true"
        fill="none"
        height="48"
        viewBox="0 0 48 48"
        width="48"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
          fill="#DBEAFE"
        />
        <path
          d="M16.5 16.5V29.8333C16.5 30.2754 16.6756 30.6993 16.9882 31.0118C17.3007 31.3244 17.7246 31.5 18.1667 31.5H31.5"
          stroke="#155DFC"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M29 28.1667V21.5"
          stroke="#155DFC"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M24.8334 28.1666V18.1666"
          stroke="#155DFC"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M20.6666 28.1666V25.6666"
          stroke="#155DFC"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
      </svg>
    </SvgIcon>
  );
}

export function AnalyzeWithAiActionIcon(): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto' }}>
      <svg
        aria-hidden="true"
        fill="none"
        height="48"
        viewBox="0 0 48 48"
        width="48"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
          fill="#DBEAFE"
        />
        <path
          d="M24.1909 14C25.8859 14.0001 27.5391 14.5261 28.9226 15.5053C30.3062 16.4846 31.3518 17.8689 31.9154 19.4675C32.4791 21.066 32.5329 22.8001 32.0695 24.4305C31.6061 26.061 30.6483 27.5075 29.3282 28.5707L29.1104 28.7413L29.7946 31.4781C29.8451 31.6808 29.8511 31.892 29.8122 32.0972C29.7732 32.3024 29.6903 32.4968 29.569 32.6668C29.4478 32.8369 29.2911 32.9787 29.1098 33.0824C28.9284 33.1861 28.7268 33.2493 28.5187 33.2676L28.3925 33.2734H19.9893C19.7803 33.2733 19.5739 33.228 19.3842 33.1404C19.1945 33.0529 19.026 32.9253 18.8903 32.7664C18.7547 32.6075 18.6551 32.421 18.5984 32.2199C18.5417 32.0188 18.5293 31.8078 18.5621 31.6014L18.5871 31.4771L19.2713 28.7403C17.8973 27.7081 16.8827 26.2698 16.3712 24.629C15.8597 22.9883 15.8772 21.2282 16.4213 19.598C16.9654 17.9678 18.0084 16.55 19.4028 15.5454C20.7972 14.5407 22.4723 14.0001 24.1909 14ZM27.2939 29.4187H21.0879L20.606 31.3461H27.7757L27.2939 29.4187ZM24.1909 15.9273C22.8325 15.9269 21.5107 16.3682 20.4249 17.1845C19.3391 18.0008 18.5481 19.148 18.1712 20.453C17.7942 21.7581 17.8518 23.1504 18.3351 24.4199C18.8184 25.6894 19.7014 26.7674 20.8508 27.4914H27.531C28.6804 26.7674 29.5633 25.6894 30.0467 24.4199C30.53 23.1504 30.5875 21.7581 30.2106 20.453C29.8336 19.148 29.0426 18.0008 27.9568 17.1845C26.871 16.3682 25.5493 15.9269 24.1909 15.9273ZM28.1516 21.2853C28.2777 21.5718 28.451 21.835 28.6642 22.064C28.8088 22.2175 28.9694 22.3531 29.1461 22.4707L29.3147 22.5738C29.3918 22.6171 29.3918 22.728 29.3147 22.7723L29.1451 22.8754C28.7068 23.1665 28.3621 23.5781 28.1525 24.0607C28.1437 24.0816 28.1288 24.0995 28.1099 24.112C28.091 24.1246 28.0688 24.1313 28.046 24.1313C28.0233 24.1313 28.0011 24.1246 27.9822 24.112C27.9632 24.0995 27.9484 24.0816 27.9396 24.0607C27.7277 23.5795 27.383 23.1687 26.946 22.8764L26.7764 22.7723C26.7587 22.7624 26.744 22.748 26.7338 22.7306C26.7236 22.7131 26.7182 22.6933 26.7182 22.673C26.7182 22.6528 26.7236 22.6329 26.7338 22.6155C26.744 22.598 26.7587 22.5836 26.7764 22.5738L26.946 22.4707C27.3843 22.1796 27.729 21.7679 27.9386 21.2853C27.9475 21.2644 27.9623 21.2466 27.9812 21.234C28.0001 21.2215 28.0224 21.2148 28.0451 21.2148C28.0678 21.2148 28.09 21.2215 28.1089 21.234C28.1279 21.2466 28.1427 21.2644 28.1516 21.2853ZM24.9772 17.4692C24.9927 17.4351 25.0176 17.4062 25.0491 17.3859C25.0805 17.3657 25.1171 17.3549 25.1546 17.3549C25.192 17.3549 25.2286 17.3657 25.26 17.3859C25.2915 17.4062 25.3164 17.4351 25.3319 17.4692C25.5415 17.947 25.8305 18.3859 26.1866 18.7673C26.5026 19.1042 26.8682 19.3909 27.2708 19.6172C27.3001 19.6336 27.3244 19.6576 27.3414 19.6865C27.3584 19.7155 27.3673 19.7485 27.3673 19.782C27.3673 19.8156 27.3584 19.8486 27.3414 19.8775C27.3244 19.9065 27.3001 19.9304 27.2708 19.9468C26.8678 20.1731 26.5019 20.4597 26.1857 20.7968C25.83 21.1779 25.5413 21.6165 25.3319 22.0939C25.3167 22.1283 25.2919 22.1576 25.2604 22.1781C25.2289 22.1987 25.1922 22.2096 25.1546 22.2096C25.117 22.2096 25.0802 22.1987 25.0487 22.1781C25.0172 22.1576 24.9924 22.1283 24.9772 22.0939C24.7676 21.6161 24.4786 21.1772 24.1225 20.7958C23.8064 20.4595 23.4408 20.1736 23.0383 19.9478C23.0088 19.9314 22.9842 19.9075 22.9671 19.8784C22.9499 19.8494 22.9409 19.8162 22.9409 19.7825C22.9409 19.7488 22.9499 19.7156 22.9671 19.6866C22.9842 19.6575 23.0088 19.6336 23.0383 19.6172C23.4413 19.3909 23.8072 19.1043 24.1234 18.7673C24.4791 18.3861 24.7678 17.9466 24.9772 17.4692Z"
          fill="#155DFC"
        />
      </svg>
    </SvgIcon>
  );
}

export function ProductCategoryIcon({ color }: { color: string }): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto', color }}>
      <svg aria-hidden="true" fill="none" height="40" viewBox="0 0 40 40" width="40">
        <path
          d="M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z"
          fill="#FAF5FF"
        />
        <path
          d="M19.1667 28.1083C19.42 28.2546 19.7074 28.3316 20 28.3316C20.2926 28.3316 20.58 28.2546 20.8333 28.1083L26.6667 24.775C26.9198 24.6288 27.13 24.4187 27.2763 24.1657C27.4225 23.9126 27.4997 23.6256 27.5 23.3333V16.6666C27.4997 16.3744 27.4225 16.0873 27.2763 15.8343C27.13 15.5812 26.9198 15.3711 26.6667 15.225L20.8333 11.8916C20.58 11.7453 20.2926 11.6683 20 11.6683C19.7074 11.6683 19.42 11.7453 19.1667 11.8916L13.3333 15.225C13.0802 15.3711 12.87 15.5812 12.7237 15.8343C12.5775 16.0873 12.5003 16.3744 12.5 16.6666V23.3333C12.5003 23.6256 12.5775 23.9126 12.7237 24.1657C12.87 24.4187 13.0802 24.6288 13.3333 24.775L19.1667 28.1083Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M20 28.3333V20"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M12.7417 15.8334L20 20L27.2584 15.8334"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M16.25 13.5583L23.75 17.85"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
      </svg>
    </SvgIcon>
  );
}

export function StructureCategoryIcon({ color }: { color: string }): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto', color }}>
      <svg aria-hidden="true" fill="none" height="40" viewBox="0 0 40 40" width="40">
        <path
          d="M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z"
          fill="currentColor"
          fillOpacity="0.08"
        />
        <path
          d="M25.8333 12.5H14.1667C13.2462 12.5 12.5 13.2462 12.5 14.1667V25.8333C12.5 26.7538 13.2462 27.5 14.1667 27.5H25.8333C26.7538 27.5 27.5 26.7538 27.5 25.8333V14.1667C27.5 13.2462 26.7538 12.5 25.8333 12.5Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M12.5 17.5H27.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M12.5 22.5H27.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M17.5 12.5V27.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M22.5 12.5V27.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
      </svg>
    </SvgIcon>
  );
}

export function StoryCategoryIcon({ color }: { color: string }): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto', color }}>
      <svg aria-hidden="true" fill="none" height="40" viewBox="0 0 40 40" width="40">
        <path
          d="M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z"
          fill="#E7F9E9"
        />
        <path
          d="M20 15.8333V27.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M12.5001 25C12.2791 25 12.0671 24.9122 11.9108 24.7559C11.7545 24.5996 11.6667 24.3877 11.6667 24.1667V13.3333C11.6667 13.1123 11.7545 12.9004 11.9108 12.7441C12.0671 12.5878 12.2791 12.5 12.5001 12.5H16.6667C17.5508 12.5 18.3986 12.8512 19.0238 13.4763C19.6489 14.1014 20.0001 14.9493 20.0001 15.8333C20.0001 14.9493 20.3513 14.1014 20.9764 13.4763C21.6015 12.8512 22.4494 12.5 23.3334 12.5H27.5001C27.7211 12.5 27.9331 12.5878 28.0893 12.7441C28.2456 12.9004 28.3334 13.1123 28.3334 13.3333V24.1667C28.3334 24.3877 28.2456 24.5996 28.0893 24.7559C27.9331 24.9122 27.7211 25 27.5001 25H22.5001C21.837 25 21.2012 25.2634 20.7323 25.7322C20.2635 26.2011 20.0001 26.837 20.0001 27.5C20.0001 26.837 19.7367 26.2011 19.2678 25.7322C18.799 25.2634 18.1631 25 17.5001 25H12.5001Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
      </svg>
    </SvgIcon>
  );
}

export function GraphicsCategoryIcon({ color }: { color: string }): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto', color }}>
      <svg aria-hidden="true" fill="none" height="40" viewBox="0 0 40 40" width="40">
        <path
          d="M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z"
          fill="currentColor"
          fillOpacity="0.08"
        />
        <g clipPath="url(#clip0_graphics_category_icon)">
          <path
            d="M21.2499 15.8333C21.48 15.8333 21.6666 15.6468 21.6666 15.4167C21.6666 15.1865 21.48 15 21.2499 15C21.0198 15 20.8333 15.1865 20.8333 15.4167C20.8333 15.6468 21.0198 15.8333 21.2499 15.8333Z"
            fill="currentColor"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.66667"
          />
          <path
            d="M24.5834 19.1667C24.8135 19.1667 25.0001 18.9801 25.0001 18.75C25.0001 18.5199 24.8135 18.3333 24.5834 18.3333C24.3533 18.3333 24.1667 18.5199 24.1667 18.75C24.1667 18.9801 24.3533 19.1667 24.5834 19.1667Z"
            fill="currentColor"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.66667"
          />
          <path
            d="M17.0834 16.6667C17.3135 16.6667 17.5001 16.4801 17.5001 16.25C17.5001 16.0199 17.3135 15.8333 17.0834 15.8333C16.8533 15.8333 16.6667 16.0199 16.6667 16.25C16.6667 16.4801 16.8533 16.6667 17.0834 16.6667Z"
            fill="currentColor"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.66667"
          />
          <path
            d="M15.4167 20.8333C15.6468 20.8333 15.8333 20.6468 15.8333 20.4167C15.8333 20.1865 15.6468 20 15.4167 20C15.1865 20 15 20.1865 15 20.4167C15 20.6468 15.1865 20.8333 15.4167 20.8333Z"
            fill="currentColor"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.66667"
          />
          <path
            d="M20.0001 11.6667C15.4167 11.6667 11.6667 15.4167 11.6667 20C11.6667 24.5833 15.4167 28.3333 20.0001 28.3333C20.7717 28.3333 21.3734 27.7117 21.3734 26.9267C21.3734 26.5625 21.2234 26.2308 21.0092 25.9892C20.7676 25.7483 20.6442 25.4458 20.6442 25.0517C20.6411 24.8682 20.6749 24.6861 20.7436 24.516C20.8124 24.3459 20.9146 24.1914 21.0443 24.0617C21.174 23.932 21.3285 23.8298 21.4986 23.761C21.6687 23.6923 21.8508 23.6585 22.0342 23.6617H23.6976C26.2401 23.6617 28.3267 21.5758 28.3267 19.0333C28.3042 15.01 24.5509 11.6667 20.0001 11.6667Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.66667"
          />
        </g>
        <defs>
          <clipPath id="clip0_graphics_category_icon">
            <rect fill="white" height="20" transform="translate(10 10)" width="20" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}

export function ConceptualCategoryIcon({ color }: { color: string }): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 'auto', height: 'auto', color }}>
      <svg aria-hidden="true" fill="none" height="40" viewBox="0 0 40 40" width="40">
        <path
          d="M0 14C0 6.26801 6.26801 0 14 0H26C33.732 0 40 6.26801 40 14V26C40 33.732 33.732 40 26 40H14C6.26801 40 0 33.732 0 26V14Z"
          fill="currentColor"
          fillOpacity="0.08"
        />
        <path
          d="M22.5 21.6667C22.6667 20.8333 23.0833 20.25 23.75 19.5833C24.5833 18.8333 25 17.75 25 16.6667C25 15.3406 24.4732 14.0688 23.5355 13.1311C22.5979 12.1934 21.3261 11.6667 20 11.6667C18.6739 11.6667 17.4021 12.1934 16.4645 13.1311C15.5268 14.0688 15 15.3406 15 16.6667C15 17.5 15.1667 18.5 16.25 19.5833C16.8333 20.1667 17.3333 20.8333 17.5 21.6667"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M17.5 25H22.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
        <path
          d="M18.3333 28.3333H21.6666"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.66667"
        />
      </svg>
    </SvgIcon>
  );
}

export function FeatureStackIcon(): ReactNode {
  return (
    <SvgIcon inheritViewBox sx={{ width: 11, height: 11, color: 'text.secondary' }}>
      <svg
        aria-hidden="true"
        fill="none"
        height="11"
        viewBox="0 0 11 11"
        width="11"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_feature_stack)">
          <path
            d="M5.88062 0.998435C5.7612 0.943962 5.63147 0.915771 5.50021 0.915771C5.36895 0.915771 5.23922 0.943962 5.11979 0.998435L1.19187 2.78594C1.11054 2.8218 1.04139 2.88053 0.992849 2.95499C0.944303 3.02945 0.918457 3.11642 0.918457 3.20531C0.918457 3.2942 0.944303 3.38117 0.992849 3.45563C1.04139 3.53009 1.11054 3.58882 1.19187 3.62469L5.12437 5.41677C5.2438 5.47124 5.37353 5.49943 5.50479 5.49943C5.63605 5.49943 5.76578 5.47124 5.88521 5.41677L9.81771 3.62927C9.89904 3.59341 9.96819 3.53467 10.0167 3.46021C10.0653 3.38575 10.0911 3.29878 10.0911 3.20989C10.0911 3.12101 10.0653 3.03404 10.0167 2.95958C9.96819 2.88512 9.89904 2.82638 9.81771 2.79052L5.88062 0.998435Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.916667"
          />
          <path
            d="M0.918458 5.5C0.918242 5.58766 0.94317 5.67355 0.990287 5.74748C1.0374 5.8214 1.10473 5.88026 1.18429 5.91708L5.12596 7.70917C5.24476 7.76296 5.37367 7.79079 5.50408 7.79079C5.6345 7.79079 5.76341 7.76296 5.88221 7.70917L9.81471 5.92167C9.89584 5.8852 9.9646 5.82592 10.0126 5.75104C10.0606 5.67617 10.0858 5.58894 10.0851 5.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.916667"
          />
          <path
            d="M0.918458 7.79211C0.918242 7.87978 0.94317 7.96567 0.990287 8.03959C1.0374 8.11352 1.10473 8.17238 1.18429 8.2092L5.12596 10.0013C5.24476 10.0551 5.37367 10.0829 5.50408 10.0829C5.6345 10.0829 5.76341 10.0551 5.88221 10.0013L9.81471 8.21378C9.89584 8.17732 9.9646 8.11803 10.0126 8.04316C10.0606 7.96829 10.0858 7.88106 10.0851 7.79211"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="0.916667"
          />
        </g>
        <defs>
          <clipPath id="clip0_feature_stack">
            <rect fill="white" height="11" width="11" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
